import React, { useMemo } from 'react';
import { useGetSurveyStonesQuery } from 'state';
import {
  stoneClassOf,
  formatCount,
  formatShortDay,
  listedStones
} from '../../fields.utils';
import {
  Card,
  Title,
  Count,
  List,
  Row,
  Dot,
  Size,
  Meta,
  RedTag,
  Message
} from './StoneList.styles';

export const StoneList = ({ surveyId, stoneCount, draft, selectedId, onSelect }) => {
  const { data: stones } = useGetSurveyStonesQuery(surveyId, { skip: stoneCount === 0 });
  const rows = useMemo(() => listedStones(stones, draft?.stoneIds), [stones, draft]);

  const renderBody = () => {
    if (stoneCount === 0) return <Message>No stones in this survey yet.</Message>;
    if (draft && draft.selected === 0) {
      return (
        <Message>
          Nothing matches. Widen the size range or raise the per-acre cap.
        </Message>
      );
    }
    return (
      <List data-testid='stone-list'>
        {rows.map(stone => {
          const first = stone.first_seen
            ? ` · first seen ${formatShortDay(stone.first_seen)}`
            : '';
          return (
            <Row
              key={stone.id}
              type='button'
              aria-current={stone.id === selectedId}
              onClick={() => onSelect(stone.id)}
            >
              <Dot $color={stoneClassOf(stone.size_class).color} />
              <span>
                <Size>
                  {stone.size_cm == null ? 'Size not known' : `${stone.size_cm} cm`}
                </Size>
                <Meta>{`Stone #${stone.id}${first}`}</Meta>
              </span>
              <span>
                {stone.size_cm != null && stone.size_cm >= draft.mustPickCm && (
                  <RedTag>red</RedTag>
                )}
              </span>
            </Row>
          );
        })}
      </List>
    );
  };

  return (
    <Card data-testid='stone-list-panel'>
      <Title>Stones {draft && <Count>{formatCount(draft.selected)}</Count>}</Title>
      {renderBody()}
    </Card>
  );
};
